import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import DropDown from "components/ui/controls/drop-down/drop-down";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import TextField from "components/ui/controls/text-field/text-field";

const ParamCavamac = (props) => {
  const context = useContext(AppContext);
  const CurrentYear = new Date().getFullYear();
  return (
    <>
      <Row tpad>
        <Column>
          <TextField
            label="Commissions brutes"
            labelStyle={{ whiteSpace: "nowrap" }}
            value={context.state[props.Outil + "CommissionBrute" + props.ClientConjoint]}
            onChange={context.handleInputChange(props.Outil + "CommissionBrute" + props.ClientConjoint)}
            dataType="uint"
            format={{ thousands: " ", unit: " €" }}
            normal
          />
        </Column>
      </Row>
    </>
  );
};
export default ParamCavamac;
